import { notification } from '@components/AppProvider';

export const handleSuccess = msg => {
	notification?.success({
		className: 'notification-black-text',
		description: msg,
		style: { backgroundColor: "#e8f5de" }
	})
}

export const handleErrors = e => {
	let messageErrors = []
	if (e.response) {
		if (e.response.status === 403) {
			messageErrors.push({
				type: "SERVER",
				message: "No tiene permiso para realizar esta acción."
			})
		} else if (e.response.status === 401) {
			messageErrors.push({
				type: "SERVER",
				message: "No esta autorizado."
			})
		} else if (e.response.status === 409) {
			messageErrors.push({
				type: "SERVER",
				message: "Ya esta asignado."
			})
		} else {
			if (!e.response.data) {
				messageErrors.push({
					type: "SERVER",
					message: "Error con el servidor."
				})
			} else if (e.response.data.description) {
				e.response.data.description.forEach(desc => {
					messageErrors.push({
						type: "INFILE",
						message: desc.mensaje_error
					})
				})
			} else if (e.response.data.code === "INSUFFICIENT_CREDIT") {
				messageErrors.push({
					type: "CREDITO",
					message: `Crédito insuficiente. Disponible: Q${e.response.data.available_credit}`,
					level: "warning"
				})
			} else if (e.response.data.message) {
				Object.keys(e.response.data.message).forEach(key => {
					messageErrors.push({
						type: "DB",
						message: `${key}: ${e.response.data.message[key]}`
					})
				})
			} else {
				messageErrors.push({
					type: "SERVER",
					message: "Error con el servidor."
				})
			}
		}
	} else {
		messageErrors.push({
			type: "NET",
			message: "Error con la red."
		})
	}


	messageErrors.forEach(error => {
		const level = error.level || "error"
		notification?.[level]({
			className: 'notification-black-text',
			title: error.type,
			description: `${error.message}`,
			style: { backgroundColor: "#f7e6e6" }
		})
	});

	return {
		isOk: false,
		errors: messageErrors
	}
}